export default __webpack_public_path__ + "static/media/step2 light.8b1a1765.svg";